<template>
    <section>
        <v-dialog v-model="dialog" persistent max-width="750px">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    <v-flex>Add / Delete Site Map</v-flex>
                    <v-btn icon @click="CloseDialog">
                        <v-icon color="text--secondary">close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-flex style="font-size: 16px;font-weight: bold;">Eg : https://prwatech.com/sitemap/sitemap.xml</v-flex>
                    <v-flex style="font-size: 16px;font-weight: bold;">Site Map Files :</v-flex>
                    <v-layout row style="overflow:auto;padding: 10px;">
                        <v-flex style="min-width: 100px;min-height: 100px;max-width: 100px;border: 1px solid lightgray;text-align: center;margin: 2px;" v-for="Site in Site_Map_List" :key="Site">
                            {{ Site }} <v-icon @click="DeleteSiteMap(Site)" color='error' style="font-size: 15px;padding: 0px 10px;">close</v-icon>
                        </v-flex>
                    </v-layout>
                    <v-flex wrap style="padding: 10px;">
                        <div style="width:400px;margin:auto;border: 1px solid #d3d3d37a;">
                            <v-flex style="text-align: center;font-size: 18px;font-weight: 600;">{{ Site_Map && Site_Map.name ? Site_Map.name : " " }}</v-flex>
                            <v-flex style="text-align: center;">
                                <v-btn color="primary" @click="$refs.inputUpload.click()">Upload Site Map</v-btn>
                                <input v-show="false" ref="inputUpload" type="file" @change="SelectedFile" >
                            </v-flex>
                        </div>
                    </v-flex>
                </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-flex style="text-align: right;">
                            <v-btn color="primary" @click="SubmitXML">Add Site Map</v-btn>
                        </v-flex>
                    </v-card-actions>
            </v-card>
        </v-dialog>
  </section>
</template>
<script>

export default {
    props: ['dialog'],
    data(){
        return {

            Site_Map         : null,
            Site_Map_List    : []

        }
    },
    methods:{
        SelectedFile(e){
        
            if(e.target.files[0]['type'] == 'text/xml'){

                this.Site_Map = e.target.files[0]

            }else{
                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Upload XML Files","Color":"red","Close": false });
            }

        },
        SubmitXML(){

            const fd = new FormData()
            fd.append('Site_Map',this.Site_Map,this.Site_Map.name)
            this.$http.post(`${this.$store.getters.GetProductionUrl}/sitemap/addsitemaptolist`,fd)
                        .then(response =>{

                            this.Site_Map_List.indexOf(response['data']['response']['filename']) === -1 ? this.Site_Map_List.push(response['data']['response']['filename']) : {}
                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Uploaded Image","Color":"green","Close": false });
                            this.CloseDialog()   
                             
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Failed To Upload Image","Color":"red","Close": false });
                        })
        },
        DeleteSiteMap(SiteMap){
    
            this.$http.post(`${this.$store.getters.GetProductionUrl}/sitemap/deletesitemapfromlist`,{"File_Name":SiteMap})
                .then(response => {

                    let index = this.Site_Map_List.findIndex(x => x == response['data']['response'])
                    this.Site_Map_List.splice(index,1)
                    this.$eventHub.$emit("SNACK_BAR", { Show: true, Text: "Successfuly Deleted File", Color: "green", Close: false});
                    this.$eventHub.$emit("LOADING",'false')
                })
                .catch(err => {
                    this.$eventHub.$emit("LOADING",'false')
                    this.$eventHub.$emit("SNACK_BAR", { Show: true, Text: "Failed To Delete FIle", Color: "red", Close: false});
                });
        },
        ClearForm(){
            this.SiteMap = null
            this.$refs.inputUpload.value = ""     
        },
        CloseDialog(){

            this.ClearForm()
            this.$emit('close')

        }
    },
    mounted(){

        this.$http.get(`${this.$store.getters.GetProductionUrl}/sitemap/sitemaplist`)
                .then(response => {

                    this.Site_Map_List = response['data']['response']
                    this.$eventHub.$emit("LOADING",'false')
                })
                .catch(err => {
                    this.$eventHub.$emit("LOADING",'false')
                    this.$eventHub.$emit("SNACK_BAR", { Show: true, Text: "Failed To Fetch Data", Color: "red", Close: false});
                });
    }
}
</script>
<style scoped>

</style>